import React from 'react';
import {
    getCurrentWindowWidth,
    getCurrentWindowHeight,
} from '@gumtree/shared/src/util/breakpoints-service';
import Maps from './maps';
import { StyledModalDialog, MapsContainer } from './MapModal.style';

export interface MapModalProps {
    isOpen: boolean;
    onClose: () => void;
    lat: any;
    long: any;
    dynamicMapApiKey: string;
    refreshMap?: boolean;
    zoom?: number;
    disableDragging?: boolean;
    displayAsSheetOnMweb?: boolean;
}

const getWidth = () => {
    const hasWindow = typeof window !== 'undefined';
    if (hasWindow && getCurrentWindowWidth(window) <= 767) {
        return '100%';
    }
    return '700px';
};

const getHeight = () => {
    const hasWindow = typeof window !== 'undefined';
    if (
        hasWindow &&
        (getCurrentWindowWidth(window) <= 767 || getCurrentWindowHeight(window) <= 700)
    ) {
        return `${getCurrentWindowHeight(window) * 0.75}px`;
    }
    return '700px';
};

const MapModal: React.FC<MapModalProps> = ({
    isOpen,
    onClose,
    lat,
    long,
    dynamicMapApiKey,
    refreshMap = true,
    zoom = 14,
    disableDragging = false,
    displayAsSheetOnMweb,
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <StyledModalDialog isOpen={isOpen} onClose={onClose} displayAsSheetOnMweb={displayAsSheetOnMweb}>
            <MapsContainer>
                <Maps
                    refreshMap={refreshMap}
                    mapApi={dynamicMapApiKey}
                    zoom={zoom}
                    lat={lat}
                    long={long}
                    width={getWidth()}
                    height={getHeight()}
                    disableDragging={disableDragging}
                />
            </MapsContainer>
        </StyledModalDialog>
    );
};

export default MapModal;
